export default __webpack_public_path__ + "static/media/covalent-bond-pic.7be5d5d0.png";